module.exports = __webpack_public_path__ + "media/src/shared_components/images/wand_icon-ae61842e9a00e08f5d26a95a4a368b47.svg";